$(window).on('load', function(){
  if ($('#modalAdv').length) {
    $('#modalAdv').modal('show');
  }
});